import type { FaireProductEntity } from "../../entity_types/product";

export const p_vy5e6xvgz6: FaireProductEntity = {
  token: "p_vy5e6xvgz6",
  type: "product",
  name: "Petal Chunky Notepad",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/9f1230ca1894308fb1c702d9022760cb58c27188db54afa0f6fa22f13e39daf4.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/027828d9d0ac3bc8df273d437faf08fc307673f37daba4740f991636421c58f7.jpeg",
  ],
  priceDollars: 9,
  description:
    "Big and chunky. It's how we like our desserts and this awesome square notepad. This is the guy you pull out when you need an extra sturdy surface for those big, chunky ideas.",
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:58.524Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
